import React, { useState } from "react";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import Context from "../../context";
import openApp from "../../action/open_app";

export default function Start(props) {
  const [state] = useState({
    container:
      "fixed text-white bg-black left-0 bottom-0 w-full md:w-4/5 lg:w-3/5 transition-all duration-500"
  });
  const [side, setSide] = useState(false);
  return (
    <div
      className={state.container + " mb-12 pb-1"}
      style={props.open ? {} : { marginBottom: "-200vh" }}
    >
      <div className="flex">
        <div className="flex">
          <ul>
            <li
              onClick={(e) => (side ? setSide(false) : setSide(true))}
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
            >
              <i className="fas fa-bars"></i>
            </li>
            <li
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              title={
                localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).name : "Anonymous"
              }
            >
              <i className="fas fa-user"></i>
              {side ? (
                <span className="-mt-1 ml-1 font-light">
                  {localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).name : "Anonymous"}
                </span>
              ) : (
                false
              )}
            </li>
            <li
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              title="Documents"
            >
              <i className="fas fa-file"></i>
              {side ? (
                <span className="-mt-1 ml-1 font-light">Documents</span>
              ) : (
                false
              )}
            </li>
            <li
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              title="Images"
            >
              <i className="fas fa-image"></i>
              {side ? (
                <span className="-mt-1 ml-1 font-light">Images</span>
              ) : (
                false
              )}
            </li>
            <li
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              title="Settings"
            >
              <i className="fas fa-cog"></i>
              {side ? (
                <span className="-mt-1 ml-1 font-light">Settings</span>
              ) : (
                false
              )}
            </li>
            <li
              className="flex p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              title="Power Off"
            >
              <i className="fas fa-power-off"></i>
              {side ? (
                <span className="-mt-1 ml-1 font-light">Power Off</span>
              ) : (
                false
              )}
            </li>
          </ul>
        </div>
        <div className="w-2/5">
          <h5 className="p-3">Apps</h5>
          <ul className="overflow-auto h-80">
            <ContextMenu
              className="bg-black border text-white font-light text-xs tracking-widest shadow-md"
              id="start_app_context"
            >
              {[
                "Pin To Start",
                "Run As Administrator",
                "Detail App",
                "Uninstall"
              ].map((d, i) => (
                <MenuItem
                  key={i}
                  className="cursor-pointer p-3 hover:bg-gray-800"
                >
                  {d}
                </MenuItem>
              ))}
            </ContextMenu>
            <Context.Consumer>
              {(data) => {
                return data.app.sort().map((d, i) => (
                  <ContextMenuTrigger key={i} id="start_app_context">
                    <li
                      key={i}
                      className="p-3 cursor-pointer hover:bg-gray-700 transition-all duration-500"
                      onClick={(e) => openApp(data, d)}
                    >
                      {d}
                    </li>
                  </ContextMenuTrigger>
                ));
              }}
            </Context.Consumer>
          </ul>
        </div>
        <div className="w-3/5 px-1 flex flex-wrap">
          <h5 className="p-3">Pinned</h5>
          <div className="overflow-auto h-80 w-full">
            <div className="flex flex-wrap">
              <div className="w-full sm:w-1/2 md:w-1/3 bg-blue-600 cursor-pointer hover:bg-blue-800 text-center p-10">
                <i className="fas fa-music"></i>
                <p>Music</p>
              </div>
              <div
                onClick={(e) => window.open("https://youtube.com")}
                className="w-full sm:w-1/2 md:w-1/3 bg-red-600 cursor-pointer hover:bg-red-800 text-center p-10"
              >
                <i className="fab fa-youtube"></i>
                <p>Youtube</p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 bg-gray-200 cursor-pointer hover:bg-gray-400 text-black text-center p-10">
                <i className="fas fa-clock"></i>
                <p>Alarm</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
